var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 54,
    viewBox: "0 0 47 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "host-brand-inactive.b0c00683 1",
    clipPath: "url(#clip0_3093_360)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.03613 53.5185H38.5674C43.4139 53.5185 46.2264 50.706 46.2264 45.3321V19.3416C46.2264 13.9677 43.3888 11.1552 37.9647 11.1552H34.424C34.2984 5.53013 29.5021 0.859375 23.5004 0.859375C17.5239 0.859375 12.7024 5.53013 12.5769 11.1552H9.03613C3.61203 11.1552 0.774414 13.9677 0.774414 19.3416V45.3321C0.774414 50.706 3.61203 53.5185 9.03613 53.5185ZM23.5004 5.30413C26.9407 5.30413 29.477 7.89062 29.5774 11.1552H17.4234C17.5239 7.89062 20.0601 5.30413 23.5004 5.30413Z",
    fill: "#9B9FA3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3093_360"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 47,
    height: 54,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBag);
export default __webpack_public_path__ + "static/media/bag.551b71b3bf6b49cdc859de5c186ff74f.svg";
export { ForwardRef as ReactComponent };